import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";
import { store } from "./store/store";
import { Provider } from "react-redux";
if (process.env.NODE_ENV === 'production') {
  // Keep error/warn, only silence log/info/debug
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
  // If you also want to kill warn/error, uncomment:
  // console.warn = () => {};
  // console.error = () => {};
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// m
reportWebVitals();
